import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { NewCampaignEditPresenter } from "./presenter";
import { useCreateNewCampaignQuery } from "../../model/repository/new/query/use-create-new-campaign-query";

import type { MarketingCampaignFormModel } from "../../model";

type Props = {
	hotelID: string;
};

export const NewCampaignEditContainer = ({ hotelID }: Props) => {
	const { data } = useCreateNewCampaignQuery({ hotelID });

	if (!data || !data.hotel.email) {
		return <Navigate to={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.TOP, { hotelID })} />;
	}

	const queryData = {
		hotelEmailAddress: data.hotel.email ?? "",
	} satisfies MarketingCampaignFormModel["QueryData"];

	return <NewCampaignEditPresenter data={data} queryData={queryData} hotelID={hotelID} />;
};

NewCampaignEditContainer.displayName = "NewCampaignEditContainer";
